module.exports = __webpack_public_path__ + "static/media/elixir-label.62fb63a3.pdf";